import TableCell from "@mui/material/TableCell";
import { HintedLabel } from "../../ui/HintedLabel";
import TableRow from "@mui/material/TableRow";
import { SiteVerificationItem } from "./useSiteVerifications";
import { StatusChip } from "./StatusChip";

export function VerificationRow(props: { item: SiteVerificationItem }) {
  const { item } = props;
  const articleBreakdown = `└ xmlRpc: ${item.articleXmlRpcValidCount} credential, api: ${item.articleApiValidCount} credential, wp-admin: ${item.articleWpAdminValidCount} credential, plugin: ${item.sitesPluginArticleValidCount} сайтов`;
  const homepageBreakdown = `└ api: ${item.homepageApiValidCount} credential, wp-admin: ${item.homepageWpAdminValidCount} credential, plugin (homepage): ${item.sitesPluginHomepageValidCount} сайтов`;
  const sitewideBreakdown = `└ plugin (sitewide): ${item.sitesPluginSitewideValidCount} сайтов`;
  const linkRemovalBreakdown = `└ api: ${item.linkRemovalApiValidCount} credential, xmlRpc: ${item.linkRemovalXmlRpcValidCount} credential, wp-admin: ${item.linkRemovalWpAdminValidCount} credential, plugin: ${item.sitesPluginLinkRemovalValidCount} сайтов`;

  const errorsList = item.errorsByType.map((event) => `${event.type}: ${event.count}`).join(", ");
  const errorsSummary = item.errorsByType.length === 0 ? "—" : errorsList;

  return (
    <TableRow>
      <TableCell>{new Date(item.createdAt).toLocaleString("ru-RU")}</TableCell>
      <TableCell>
        <StatusChip status={item.status} />
      </TableCell>
      <TableCell align="right">{item.checkedCount} / {item.totalCredentials}</TableCell>
      <TableCell align="right">
        <HintedLabel hint={articleBreakdown}>{item.sitesArticleValidCount} из {item.totalSites} сайтов</HintedLabel>
      </TableCell>
      <TableCell className="tabular-nums" align="right">{item.sitesArticleInvalidCount}</TableCell>
      <TableCell align="right">
        <HintedLabel hint={homepageBreakdown}>{item.sitesHomepageValidCount} из {item.totalSites} сайтов</HintedLabel>
      </TableCell>
      <TableCell className="tabular-nums" align="right">{item.sitesHomepageInvalidCount}</TableCell>
      <TableCell align="right">
        <HintedLabel hint={sitewideBreakdown}>{item.sitesPluginSitewideValidCount} из {item.totalSites} сайтов</HintedLabel>
      </TableCell>
      <TableCell className="tabular-nums" align="right">{item.sitesPluginSitewideInvalidCount}</TableCell>
      <TableCell align="right">
        <HintedLabel hint={linkRemovalBreakdown}>{item.sitesLinkRemovalValidCount} из {item.totalSites} сайтов</HintedLabel>
      </TableCell>
      <TableCell className="tabular-nums" align="right">{item.sitesLinkRemovalInvalidCount}</TableCell>
      <TableCell>
        {errorsSummary}
      </TableCell>
    </TableRow>
  );
}
